"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useFetch_1 = __importDefault(require("../hooks/useFetch"));
const common_styled_components_1 = require("./common-styled-components");
exports.default = () => {
    const [token] = (0, useFetch_1.default)("calculator/token.json", undefined);
    console.info(token);
    return ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.TextContent, { style: { marginTop: 100, textAlign: "center" }, children: token.status === "Success"
                ? `${token.data.token.user_email}, ${token.data.token.exp}`
                : token.status }) }));
};
